module.exports = __webpack_public_path__ + "img/chevron-down.8ee597e0.svg";